<template>
    <div :class="$style.wrapper">
        <GameCard
            v-for="(game, index) in props.games"
            :key="index"
            type="square-without-title"
            :game="game"
            :targetLink="props.gameLinkTarget"
            :data-interface-target="`game-number-${index + 1}`"
            responsive
            :lazy="!props.eagerThumbs || index >= props.eagerThumbs"
            :preload="props.preloadFirstCard && index === 0"
            withBadges
            withScaleOnHover
        />
        <MoreGamesCard
            :games="props.games.slice(props.games.length - 3)"
            type="square-without-title"
            :to="props.link"
            :categoryName="props.categoryName"
        />
    </div>
</template>
<script lang="ts" setup>
import type { RouteLocationRaw } from 'vue-router'

import GameCard from '@/components/GameCard/GameCard.vue'
import type { LinkTarget, ShortGameType } from '@/types'

import MoreGamesCard from './MoreGamesCard.vue'

const props = defineProps<{
    games: ShortGameType[] | undefined[]
    eagerThumbs?: number
    gameLinkTarget: LinkTarget | undefined
    preloadFirstCard?: boolean
    link?: RouteLocationRaw
    categoryName?: string
}>()
</script>
<style module>
.wrapper {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px 8px;
    margin-bottom: 10px;
}

.wrapper > :nth-child(-n + 8) {
    display: flex;
}

.wrapper > :nth-child(n + 8) {
    display: none;
}

@media (width >= 500px) {
    .wrapper {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        gap: 12px 8px;
    }

    .wrapper > :nth-child(-n + 12) {
        display: flex;
    }

    .wrapper > :nth-child(n + 12) {
        display: none;
    }
}

@media (width >= 640px) {
    .wrapper {
        grid-template-columns: repeat(8, 1fr);
    }

    .wrapper > :nth-child(-n + 16) {
        display: flex;
    }

    .wrapper > :nth-child(n + 16) {
        display: none;
    }
}

@media (width >= 960px) {
    .wrapper {
        grid-template-columns: repeat(10, minmax(50px, 1fr));
    }

    .wrapper > :nth-child(-n + 10) {
        display: flex;
    }

    .wrapper > :nth-child(n + 10) {
        display: none;
    }
}

@media (width >= 1300px) {
    .wrapper {
        grid-template-columns: repeat(12, minmax(50px, 1fr));
    }

    .wrapper > :nth-child(-n + 12) {
        display: flex;
    }

    .wrapper > :nth-child(n + 12) {
        display: none;
    }
}

@media (width >= 1520px) {
    .wrapper {
        grid-template-columns: repeat(14, minmax(50px, 1fr));
    }

    .wrapper > :nth-child(-n + 14) {
        display: flex;
    }

    .wrapper > :nth-child(n + 14) {
        display: none;
    }
}

/* Ensure the last card (MoreGamesCard) is always visible */
.wrapper > :last-child {
    display: flex;
}
</style>
